<template>
  <div>
    <template v-for="(component, index) in components">
      <template v-if="component.name === 'InstallWebappPopup'">
        <component
          :is="component.name"
          :data="component.data"
          :key="index"
          @setInstallPopupPosition="setInstallPopupPosition"
        ></component>
      </template>
      <template v-else>
        <v-container :key="index">
          <component
            :is="component.name"
            :data="component.data || component.props"
          ></component>
        </v-container>
      </template>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import {mapGetters} from 'vuex'
import {storage} from '@/store'
import Profile from '@/components/profile/Profile'
import ProfileMenu from '@/components/profile/ProfileMenu'
import ActivityFeed from '@/components/ActivityFeed'
import HelpSection from '@/components/HelpSection'
import InstallWebappPopup from '@/components/promotion/InstallWebappPopup'
import BannerSlider from '@/components/bounty/BannerSlider'
import RewardsOverview from '@/components/bounty/RewardsOverview'
import SweepstakesOverview from '@/components/bounty/SweepstakesOverview'
import BountyCarousel from '@/components/bounty/BountyCarousel'
import PageComponent from '@/components/PageComponent'
import PointPoolComponent from '@/components/PointPoolComponent'

export default {
  name: 'Home',
  components: {
    ActivityFeed,
    Profile,
    ProfileMenu,
    HelpSection,
    InstallWebappPopup,
    RewardsOverview,
    SweepstakesOverview,
    BannerSlider,
    BountyCarousel,
    PageComponent,
    PointPoolComponent
  },
  data() {
    return {
      promotionStorage: JSON.parse(storage.getItem('promotion'))
    }
  },
  computed: {
    ...mapGetters(['appScreens', 'loadingExtensionSettings']),
    components() {
      if (this.loadingExtensionSettings) {
        return []
      }

      return _.get(this.appScreens, 'loyalty.components', [])
    }
  },
  mounted() {
    if (
      _.get(this.promotionStorage, 'discreetWebappInstaller', false)
    ) {
      this.setInstallPopupPosition()
    }
  },
  methods: {
    // moves Add-To-Homescreen-Box further down to be less intrusive
    setInstallPopupPosition() {
      this.components.splice(2, 0, this.components.splice(1, 1)[0])
      this.components[2].data = {persistent: true}
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  margin-bottom: 48px;
}
</style>
